import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";

function Card({ item }) {
  return (
    <div className="rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] overflow-hidden">
      <div className="grid grid-cols-2">
        <div className="relative"><span className="absolute top-2 left-2 text-[10px] bg-black/50 text-white px-2 py-0.5 rounded-full">Before</span><img src={item.before_image} alt="before" loading="lazy" className="w-full h-40 object-cover" /></div>
        <div className="relative"><span className="absolute top-2 left-2 text-[10px] bg-[var(--cdt-primary)] text-white px-2 py-0.5 rounded-full">After</span><img src={item.after_image} alt="after" loading="lazy" className="w-full h-40 object-cover" /></div>
      </div>
      <div className="p-4">
        <h3 className="font-display text-lg text-[var(--cdt-text)]">{item.title}</h3>
        <p className="text-xs text-[var(--cdt-muted)] mt-1">{item.caption}</p>
      </div>
    </div>
  );
}

export default function BeforeAfter() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const categories = ["All", ...Array.from(new Set(items.map((i) => i.category)))];

  return (
    <>
      <Seo title="Before & After" description="Before and after gallery of treatments at CDT (consent-based placeholders)." path="/before-after" />
      <PageHeader eyebrow="Results Gallery" title="Before &amp; After" subtitle="A growing gallery of real outcomes. Images are shown with consent; placeholders are used until clinical photos are added." />

      <section className="py-14 lg:py-20" data-testid="before-after-gallery">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Tabs defaultValue="All">
            <TabsList className="flex flex-wrap h-auto bg-transparent gap-2 justify-start">
              {categories.map((c) => (
                <TabsTrigger key={c} value={c} data-testid={`gallery-tab-${c}`} className="data-[state=active]:bg-[var(--cdt-primary)] data-[state=active]:text-white rounded-full border border-[color:var(--cdt-border)] px-4">{c}</TabsTrigger>
              ))}
            </TabsList>
            {categories.map((c) => (
              <TabsContent key={c} value={c} className="mt-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {items.filter((i) => c === "All" || i.category === c).map((item, idx) => (
                    <Reveal key={item.id || idx} delay={(idx % 3) * 0.06}><Card item={item} /></Reveal>
                  ))}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
